<!--
 * @Description: 首页登录
 * @Autor: txp
 * @Date: 2021-03-29 10:01:35
-->
<template>
  <div class="login">
    <div class="header">
      <div>
        <img :src="bizImg" alt="" />
        <span>DMS经销商商城</span>
      </div>
    </div>
    <div class="main_box">
      <div class="main">
          <div class="title">登录商城</div>
          <el-form
            :rules="rules"
            :model="loginForm"
            ref="loginForm"
            class="demo-ruleForm">
            <el-form-item prop="userName">
              <el-input
                prefix-icon="el-icon-user"
                placeholder="账户"
                v-model="loginForm.userName"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                prefix-icon="el-icon-unlock"
                type="password"
                placeholder="密码"
                v-model="loginForm.password">
              </el-input>
            </el-form-item>
            <div class="flex justify_content_between mt10">
                <div class="">
                  <el-checkbox v-model="checked" @change="checkbox"></el-checkbox>
                  <span> 记住账户</span>
                </div>
                <div @click="forgetPass" class="flex flexalignitem_center">
                  <img style="vertical-align: middle;line-height:20px;" src="@/assets/img/forgetpass.png" alt="">
                  <p class="forgotpassword">忘记密码</p>
                </div>
              </div>
              <div class="mtb1525">
                <el-button type="primary" :loading="loginLoading" @click="submitFrom">登录</el-button>
               </div>
          </el-form>
          <div class="uesrdms">
              <p><img width="90px" height="90px" :src="Code" alt=""></p>
              <p class="mt10">DMS小程序</p>
          </div>
      </div>
    </div>
    <div class="footer">
      <div class="footerTop">
        <span>帮助</span>
        <span>隐私</span>
        <span>条款</span>
      </div>
      <div class="footer_info">
         粤ICP备15041459号-2 翠林信科 版权所有
      </div>
      <div class="footer_info">
         Copyright ©2016 深圳市恒大饮品有限公司,All Rights Reserved
      </div>
    </div>
    <ForgotPassword :visible="forgotVisible" @onClose="closeForgot"/>
  </div>
</template>
<script>
import Code from "@/assets/img/codes.jpg";
import bizImg from "@/assets/img/biz.png";
import {Storage} from "@/utils/storage"
import {Login} from "@/api/api"
import {encodeKey} from '@/utils'
import CryptoJS from "crypto-js"
import ForgotPassword from './forgotPassword.vue'
export default {
  name: "login",
  components: {
    ForgotPassword
  },
  data() {
    return {
      Code,
      bizImg,
      checked:false,
      loginForm: {
        userName: "", //DM S10002
        password: ""  //123456
      },
      //   验证规则
      rules: {
        userName: [
          { required: true, message: "账号不能为空", trigger: "blur" }, // 非空
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" }, // 非空
        ]
      },
      loginLoading: false,
      forgotVisible: false
    }
  },
  methods:{
    /**
     * @description:  Login 登录接口获取token
     * @param {*} userName 用户名  
     * @param {*} password  密码
     * @return {*}   customerName 接口调用时取   customerName 获取经销商名称      
     * @author: txp
     */
    submitFrom(){
      /**
       * @description: 登录
       * @param {*} 
       * @return {*}
       * @author: txp
       */
      let params = {
        ujlrwebjruzddjnu:this.loginForm.userName,
        pazjofxkyvyoosot: encodeKey(this.loginForm.password)   
      }
      this.loginLoading = true
      Login(params).then((res)=>{
        this.loginLoading = false
        if(res.code === 200){
            Storage.l.set('TokenKey',res.result.loginUserToken);
            Storage.l.set('customerCode',res.result.customerCode);
            Storage.l.set('customerName',res.result.customerName);
            Storage.l.set('userName',this.loginForm.userName);
            Storage.l.set('resetPassword',res.result.resetPassword)
            // Storage.l.set('password',this.loginForm.password);
            this.$router.push("/home");
        }
      }).catch(error=>{
        this.loginLoading = false
        // this.$message.error(error)
      });
    },
    // 记住账户
    checkbox(val){
      this.checked = val
    },
    // 忘记密码
    forgetPass(){
      // this.$message.error('请联系管理员')
      this.forgotVisible = true;
    },
    //关闭忘记密码弹窗
    closeForgot() {
      this.forgotVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.forgotpassword{
  cursor: pointer;
}
.login {
  height: 100vh;
  display: flex;
  // justify-content: center;
  flex-direction: column;
  .header {
    top: 0;
    height: 80px;
    width: 100%;
    background-color: #fff;
    display: flex;
    align-items: center;
    div {
      display: flex;
      align-items: center;
      position: relative;
      left: 160px;
      img {
        width: 80px;
        // width: 90.8px;
        // height: 40.8px;
        margin-right: 20px;
      }
      span {
        font-size: 30px;
        color: #787878;
        letter-spacing: 0;
        line-height: 28px;
      }
    }
  }
  .main_box{
      flex: 1;
      background: url("~@/assets/img/bg-login.jpg") center / cover no-repeat;
      position: relative;
      // background-position: 0 0;
      // max-height: 600px;
      .main {
        position: absolute;
        top: 50%;
        transform: translate(0,-50%);
        margin-left: calc(65%);
        width: 352px;
        // height: 85%;
        height: 460px;
        box-sizing:border-box;
        padding: 30px;
        border-radius: 6px;
        background-color: #ffffff;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title {
          font-size: 20px;
          color: #787878;
          letter-spacing: 0;
          line-height: 28px;
          margin-bottom: 20px;
        }
       /deep/.el-button{
          width: 100%;
        }
        .uesrdms{
          text-align: center;
          p{
            font-size: 14px;
            color: #1D1D1D;
            text-align: center;
            line-height: 22px;
          }
        }
     }
  }
  .footer {
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    height: 120px;
    background-color: #ffffff;
    color: #252525;
    line-height: 20px;
    div:last-child {
      color: #c5c5c5;
    }
    .footerTop {
      margin-bottom: 15px;
      span {
        display: inline-block;
        margin-right: 20px;
        font-size: 14px;
        font-weight: 600;
      }
      span:last-child {
        margin-right: 0;
      }
    }
    .footer_info {
      font-size: 12px;
    }
  }
}
</style>
